import * as types from '../../actions/types';

const initialState = null

export default function courses (state = initialState, action) {
  switch (action.type) {
    case types.SET_REVIEWS_COURSES:
      return action.payload
    default:
      return state;
  }
}
